import type { Topic, TopicProgress, TopicSummary } from "../types/reviseTypes";

export function buildTopicSummaryList(
  topics: Topic[] | undefined,
  topicsProgress: TopicProgress[] | undefined,
): TopicSummary[] {
  if (!topics) return [];

  const progressMap = new Map<number, TopicProgress>(
    topicsProgress?.map((t) => [t.topicId, t]) ?? [],
  );

  const filtered = topics.filter((t) => (t.publishedFlashcardCount ?? 0) > 0);

  return filtered.map((topic, index) => {
    const progress = progressMap.get(topic.topicId);
    const count = progress?.count ?? 0;

    const publishedFlashcardCount =
      (topic.publishedFlashcardCount ?? 0) +
      (topic.flashcardTaggedQuestionsCount !== 0 ? 1 : 0);

    const flashCardCurrentCount = Math.min(count, publishedFlashcardCount);

    const progressPercent =
      publishedFlashcardCount === 0
        ? 0
        : (flashCardCurrentCount / publishedFlashcardCount) * 100;

    const reviseExists = topic.flashcardTaggedQuestionsCount !== 0 ? 1 : 0;

    const safeCount = progress?.count ?? 1;

    const resumeFlashcardOrder =
      reviseExists && progress?.count === topic.publishedFlashcardCount
        ? safeCount - 1
        : safeCount;

    return {
      ...topic,
      watchFlashCardCount: flashCardCurrentCount,
      practiceCardSequenceNumber: index + 1,
      totalCount: publishedFlashcardCount,
      progressPercent,
      isReviseQuestionIsThere: reviseExists,
      cardText: `${flashCardCurrentCount}/${publishedFlashcardCount}`,
      resumeFlashcardOrder,
    };
  });
}
